export default {"src":"/_next/static/media/PLUS_ICON_GREY.a8697c3a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};